import styled from "styled-components";
import { pxIntoRem } from "../../utils/pxIntoRem";

const HomeBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f8f9fa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  padding: ${pxIntoRem(20)} 0;
  position: relative;
`;

const HomeContent = styled.div`
  background: white;
  padding: ${pxIntoRem(60)} ${pxIntoRem(40)};
  border-radius: ${pxIntoRem(12)};
  box-shadow: 0 ${pxIntoRem(2)} ${pxIntoRem(12)} rgba(0, 0, 0, 0.08);
  width: 100%;
  max-width: ${pxIntoRem(600)};
  border: ${pxIntoRem(1)} solid #e9ecef;
  text-align: center;
`;

const HomeTitle = styled.h1`
  text-align: center;
  margin-bottom: ${pxIntoRem(32)};
  color: #212529;
  font-size: ${pxIntoRem(28)};
  font-weight: 600;
  letter-spacing: -0.02em;
`;

const HomeImageCount = styled.div`
  font-size: ${pxIntoRem(48)};
  font-weight: 700;
  color: #212529;
  margin-bottom: ${pxIntoRem(16)};
`;

const HomeMessage = styled.p`
  color: #495057;
  font-size: ${pxIntoRem(18)};
  margin-bottom: ${pxIntoRem(32)};
  line-height: 1.5;
`;

const HomeStartButton = styled.button`
  padding: ${pxIntoRem(14)} ${pxIntoRem(24)};
  background: #212529;
  color: white;
  border: none;
  border-radius: ${pxIntoRem(8)};
  font-size: ${pxIntoRem(15)};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: ${pxIntoRem(16)};

  &:hover {
    background: #343a40;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const HomeLogoutButton = styled.button`
  position: absolute;
  top: ${pxIntoRem(20)};
  right: ${pxIntoRem(20)};
  padding: ${pxIntoRem(10)} ${pxIntoRem(16)};
  background: transparent;
  color: #6c757d;
  border: ${pxIntoRem(1)} solid #dee2e6;
  border-radius: ${pxIntoRem(6)};
  font-size: ${pxIntoRem(14)};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    border-color: #adb5bd;
  }
`;

export { HomeBlock, HomeContent, HomeImageCount, HomeLogoutButton, HomeMessage, HomeTitle, HomeStartButton };
